import { baseUser } from '@/models/users'

export default {
  tokenAccess: null,
  tokenRefresh: null,
  user: baseUser,
}
